import { getContractsByCustomerId } from '@/modules/Customer/services'
import { FieldValues, Path, UseFormReturn } from 'react-hook-form'
import { Option } from 'vnetwork-ui/dist/components/FormItem'
import AsyncSelect from '../AsyncSelect'

interface CustomerContractSelectProps<T extends FieldValues> {
    control: UseFormReturn<T, any, any>['control']
    name: Path<T>
    placeholder: string
    customer_id: number
    afterFetch?: (data: Option[]) => void
}

const CustomerContractSelect = <T extends FieldValues>({
    control,
    name,
    placeholder,
    customer_id,
    afterFetch,
}: CustomerContractSelectProps<T>) => {
    return (
        <AsyncSelect<T>
            name={name}
            control={control}
            asyncOptions={async () =>
                customer_id
                    ? getContractsByCustomerId({
                          customer_id,
                          page: 1,
                          page_size: 50,
                          q: '',
                      })
                          ?.then((res) => res?.results || [])
                          .then((res) =>
                              res?.map((item) => ({
                                  label: item.contract_number_id,
                                  value: item.contract_id,
                              }))
                          )
                    : []
            }
            placeholder={placeholder}
            label={placeholder}
            dependencies={[customer_id]}
            disabled={!customer_id}
            afterFetch={afterFetch}
            allowClear={false}
        />
    )
}

export default CustomerContractSelect
